import {useSelector} from 'react-redux';

import DEVICE_TYPES from '../enums/device/deviceTypes';
import deviceTypesService from '../services/device/deviceTypesService';
import {selectIotDeviceType} from '../state/selectors/iotDevice';

const useDeviceTypeStyles = (customDeviceType, isVideoContent) => {
    const deviceType = useSelector(selectIotDeviceType);
    const preparedDeviceType = customDeviceType ? customDeviceType : deviceType;
    const isP1V4 = deviceTypesService.isP1V4(preparedDeviceType);
    const isArianeDevice = preparedDeviceType === DEVICE_TYPES.DEV_TYPE_P1_ARIANE;
    const isP1V41 = deviceTypesService.isP1V41(preparedDeviceType);
    const isJuno = deviceTypesService.isJuno(preparedDeviceType);

    if (isJuno && isVideoContent) return 'bg-java';
    if (isP1V41) return 'bg-tertiary';
    if (isP1V4) return 'bg-java';
    if (isArianeDevice) return 'bg-fluorescent-red';

    return 'bg-tertiary';
};

export default useDeviceTypeStyles;
